module.exports = __webpack_public_path__ + "img/4-1-north-1.8adc1daf.jpg";